import { defineAsyncComponent } from 'vue'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default async ({ app }) => {
  // It's very likely that a component using ModelForm will also use one of the ModelForm field components,
  // which only work within ModelForms. Rather than require each ModelForm user to import these components
  // components every time, we make them globally available as soon as ModelForm is first bundled/loaded.
  // Less commonly used components can be registered with dynamic import functions for lazy loading.
  app.component('ModelFormCheckbox', defineAsyncComponent(() => import('src/modules/admin/components/ModelForm/components/ModelFormCheckbox')))
  app.component('ModelFormFileUploader', defineAsyncComponent(() => import('src/modules/admin/components/ModelForm/components/ModelFormFileUploader')))
  app.component('ModelFormImageUploader', defineAsyncComponent(() => import('src/modules/admin/components/ModelForm/components/ModelFormImageUploader')))
  app.component('ModelFormInput', defineAsyncComponent(() => import('src/modules/admin/components/ModelForm/components/ModelFormInput')))
  app.component('ModelFormSelect', defineAsyncComponent(() => import('src/modules/admin/components/ModelForm/components/ModelFormSelect')))
  app.component('ModelFormToggle', defineAsyncComponent(() => import('src/modules/admin/components/ModelForm/components/ModelFormToggle')))
  app.component('ModelFormButtonToggle', defineAsyncComponent(() => import('src/modules/admin/components/ModelForm/components/ModelFormButtonToggle')))
}
